let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eybtm")).then(() => parcelRequire('k7UXO'));